

<template>
  <v-container>
      <v-card class="modal-backdrop" style="background-color: rgba(211, 211, 211, 0.596);" ref="modal" id="loginModal" data-keyboard="false" data-backdrop="static" v-hide="otpSuccess == true" v-show="otpSuccess ==true">
      <div class="modal otpModal">
        <section class="modal-body">
          <slot name="body">
              <v-flex style="text-align: center;font-size: 20px;">
                             <b><label style="font-family: Arial;" > OTP Verification</label></b>
              </v-flex>
              <br/>
          
    <div style="padding-bottom: 8px;">
          <v-flex style="padding-left:2rem; padding-right: 2rem; text-align: center;"> 
      <label class="grey--text text--darken-2">
              <p style="font-family: Arial;font-size: 11px;">  <b>Enter OTP sent to registered Mobile/Email ID.</b></p> 
          </label>
          <h5 style="font-family: Arial;color: darkgrey; font-size: 11px;" id="otpMsgE">OTP will expire in 3 minutes. Do not share with anyone.</h5>
      <div class ="container">
          <div class="row">
  
              <div class="float-child" style="border-radius: 8px !important;">
           <!-- <v-text-field  class="mt-2 mb-0" type="password" inputmode="numeric" transition="slide-x-transition" id="11" autocomplete="off" maxLength="1" solo  v-model="emailOtp1" @input="moveToNextField($event, 11)"
                        @keydown="moveToPreviousField($event, 11)" oncopy="return false" onpaste="return false"  oninput="javascript:   this.value = this.value.replace(/[^0-9]/gi, '');" Arial>
           </v-text-field> -->
           <v-text-field class="mt-2 mb-0" type="password" inputmode="numeric" id="11" autocomplete="off" :maxlength="1" solo v-model="emailOtp1" @input="moveToNextField($event, 11)" @keydown="moveToPreviousField($event, 11)" @keypress="restrictToNumeric($event)" @copy.prevent @paste.prevent ></v-text-field>
          </div>
          <div class="float-child">
            <v-text-field class="mt-2 mb-0" type="password" inputmode="numeric" id="12" autocomplete="off" :maxlength="1" solo v-model="emailOtp2" @input="moveToNextField($event, 12)" @keydown="moveToPreviousField($event, 12)"  @keypress="restrictToNumeric($event)" @copy.prevent @paste.prevent ></v-text-field>
          </div>
          <div class="float-child">
            <v-text-field class="mt-2 mb-0" type="password" inputmode="numeric" id="13" autocomplete="off" :maxlength="1" solo v-model="emailOtp3" @input="moveToNextField($event, 13)" @keydown="moveToPreviousField($event, 13)" @keypress="restrictToNumeric($event)" @copy.prevent @paste.prevent ></v-text-field>
          </div>
          <div class="float-child">
            <v-text-field class="mt-2 mb-0" type="password" inputmode="numeric" id="14" autocomplete="off" :maxlength="1" solo v-model="emailOtp4" @input="moveToNextField($event, 14)" @keydown="moveToPreviousField($event, 14)"  @keypress="restrictToNumeric($event)" @copy.prevent @paste.prevent ></v-text-field>
          </div>
          <div class="float-child">
            <v-text-field class="mt-2 mb-0" type="password" inputmode="numeric" id="15" autocomplete="off" :maxlength="1" solo v-model="emailOtp5" @input="moveToNextField($event, 15)" @keydown="moveToPreviousField($event, 15)" @keypress="restrictToNumeric($event)" @copy.prevent @paste.prevent ></v-text-field>
          </div>
          <div class="float-child">
            <v-text-field class="mt-2 mb-0" type="password" inputmode="numeric" id="16" autocomplete="off" :maxlength="1" solo v-model="emailOtp6" @input="moveToNextField($event, 16)" @keydown="moveToPreviousField($event, 16)" @keypress="restrictToNumeric($event)" @copy.prevent @paste.prevent ></v-text-field>
          </div>
  
  
          </div>
      </div>
  
      </v-flex>
  
      
          <div style="color:red;font-size:11px;margin: 2px 45px 0px; text-align: left;" v-if="otpMailerrormsg.length > 0">{{otpMailerrormsg}}</div><br/> 
           <span style="padding-left:4rem; padding-right: 2rem; text-align: center;">Didn't Receive OTP? 
            <button type="button" style="font-size:11px;" :class="{ activeLink: !isOtpMail }"  :disabled='isOtpMail' id="emailResendBtn"  v-on:click="otpResendMail()" v-if="!emailSuccess"> Resend OTP {{otpTimerMail}} {{ otpMailMins }} </button>
      </span>
          </div>
          </slot>
         </section>
  
        <v-flex class="modal-footer" style="align-items: center;border-top: none !important;">
          <v-layout justify-center>
              <v-flex style="align-items: center;">
                  <v-btn :disabled ='$sunidhi.isdisableProceedBtn' style="border-radius: 20px !important;" color="primary-btn" dark block class="text-none" v-on:click="PreLoader=true;otpValidation()">&nbsp; &nbsp; Proceed &nbsp; &nbsp;
                  </v-btn>
              </v-flex>
          </v-layout>
      </v-flex>
      </div>
    </v-card>
  <!-- </v-container> -->
  <!-- <v-container> -->
  <div class="otpCardStyle otpSuccessPopUp" style="text-align: center;" v-show="otpSuccess == true" v-hide="otpSuccess == false">
      <img style="width: 75px;" src="@/assets/images/GreenTickIcon.svg"/>
    <h1 class="pwdUpdatedStyle"> Verification Code Success! </h1><br>
    <h3 style="font-size: 20px;">Your Account has been verified successfully!</h3>
              <div class="buttonWrapper">
               <button type="submit"  @click="OTPSuccess()" class="submitButton pure-button pure-button-primary">
                   <span>OK</span>
               </button>
               </div>
  </div>
  
  
   <!--Preloader starts-->
   <div class="pre-loader" v-show="PreLoader==true" v-hide="PreLoader == false">
    
    <img :src="preLoaderImg">
  
  </div>
  
  <!--Preloader ends-->
  </v-container>
  </template>
  
  <script>
  import router from '@/router';
  import { reactive } from 'vue';
  import { db, externalURL, sunidhiPlugin } from '@/sunidhiapp';
  import axios from 'axios';
  import $ from 'jquery';
  import loader from '@/assets/images/Preloader.gif';
  import { getSessionId } from '@/services/sessionservice';

  
  
  export default {
    name: 'OtpPage',
    data: function () {
      return {
        dsaLoginErrorMsg :'', 
        emailOtp1: '',
        emailOtp2: '',
        emailOtp3: '',
        emailOtp4: '',
        emailOtp5: '',
        emailOtp6: '',
        emailOtp: "",
        otpSuccess: false,
        isDispForgotPwdOTP: false,
        isDispTwoFactorAuthOTP: false,
        loginUserIDValue: "",
        loginUserIDValueEncrypt: "",
        PreLoader: false,
        otpMailerrormsg: "",
        otpSuccessMsg: "",
        isOtpMail: true,
        otpTimerMail: 0,
        otpTimerMailSecs: 0,
        emailSuccess: false,
        otpMailMins: 'min',
        mailOtpCount: 0,
        isFlag: false,
        preLoaderImg: loader,
        backbuttonpressed: false,
        
        // isdisableProceedBtn: true
        // logoutBtnDisp: 'true'
  
  
      };
    },
  
    watch: {
      otpTimerMail: {
        handler(value) {
          // if(this.isModalVisible){
          if (value > 0) {
            // this.otpMailMins='min'
            setTimeout(() => {
  
              this.otpTimerMail--;
              // this.otpTimerMailSecs = 60;
            }, 1000);
          } else {
              // $("#emailResendBtn").addClass("activeLink");
            this.otpTimerMail = "";
            this.otpMailMins = ''
            this.isOtpMail = false;
          }
          // }
  
        },
        immediate: true // This ensures the watcher is triggered upon creation
      },
    },
  
    mounted: async function () {
      sessionStorage.removeItem('DUPLICATE_SESSION_HANDLED')
      // debugger;
    //   window.onpopstate = (e) => {
    //   this.backbuttonpressed = true;
    // };

    // Listen for the page unload (refresh or close)
    // window.addEventListener('beforeunload', this.handleBeforeUnload);
    const sunidhi = reactive(sunidhiPlugin);
      this.otpTimerMail = 180; // timer for 3 mins
      this.otpMailMins = 'secs'
      this.isOtpMail = true; //disable the resend OTP link
      sunidhi.logoutBtnDisp = false;
      this.PreLoader = false;
  
      var genzdata = await db.TbGenz.where("UserId").anyOf(1).toArray();
      if (genzdata != null && genzdata.length > 0) {
        if (genzdata[0].loginType != undefined || genzdata[0].loginType != null) {
          if (genzdata[0].loginType == "FORGOTPASSWORDUPDATE") {
            this.isDispForgotPwdOTP = true;
            this.isDispTwoFactorAuthOTP = false;
          } else {
            this.isDispForgotPwdOTP = false;
            this.isDispTwoFactorAuthOTP = true;
          }
        } else {
          this.isDispTwoFactorAuthOTP = true;
          this.isDispForgotPwdOTP = false;
        }
      }
    },

  //   beforeRouteLeave(to, from, next) {
  //   if (this.backbuttonpressed) {
  //     // Handle condition when back button was pressed
  //     if (confirm('You may have unsaved changes. Do you want to continue?')) {
  //       this.backbuttonpressed = false; // Reset the flag
  //       next();
  //     } else {
  //       next(false); // Cancel navigation
  //     }
  //   } else {
  //     next(); // Continue navigation
  //   }
  // },

  //   beforeDestroy() {
  //   // Clean up event listener
  //   window.removeEventListener('beforeunload', this.handleBeforeUnload);
  // },
    
    methods: {
    //   handleBeforeUnload(event) {
    //   const message = 'You may have unsaved changes. Do you want to continue?';
    //   event.returnValue = message; // Standard way to trigger the confirmation dialog
    //   return message; // Some browsers require this for the confirmation dialog to show
    // },
 
      
      moveToNextField(event, id) {
        this.$sunidhi.isdisableProceedBtn = id < 16 ? true : false;
        if (event.length === 1) {
          const nextInput = document.getElementById(id + 1);
          if (nextInput) {
            nextInput.focus();
          }
        }
      },
      moveToPreviousField(event, id) {
        this.$sunidhi.isdisableProceedBtn = id < 16 ? true : false;
        if (event.key === 'Backspace' && event.target._value.length === 0) {
          const prevInput = document.getElementById(id - 1);
          if (prevInput) {
            prevInput.focus();
          }
        }
      },
      restrictToNumeric(event) {
        const charCode = event.charCode;
        // Only allow numeric characters (0-9)
        if (charCode < 48 || charCode > 57) {
          event.preventDefault();
        }
      },
  
      // moveToNextField(e, id) {
      //   this.$sunidhi.isdisableProceedBtn = id < 16 ? true : false;
  
      //   if (e.length === 1) {
      //     const nextIndex = id + 1;
      //     if (nextIndex <= 16) {
      //       document.getElementById(nextIndex).focus();
      //     }
      //   }       
      //         },
      // moveToPreviousField(event, id) {
      //   if (event.key === 'Backspace' && event.target.value.length === 0) {
      //     const prevInput = document.getElementById(id - 1);
      //     if (prevInput) {
      //       prevInput.focus();
      //     }
      //   }
      // },
      
      sanitizeInput(event) {
        event.target.value = event.target.value.replace(/[^0-9]/gi, '');
      },
      async otpValidation() {
        var self = this;
        this.isFlag = true;
        self.otpSuccess = false;
        self.emailOtp = self.emailOtp1 + self.emailOtp2 + self.emailOtp3 + self.emailOtp4 + self.emailOtp5 + self.emailOtp6;
        self.otpMailerrormsg = "";
        self.otpEmail = false;
        if (self.emailOtp.length <= 5) {
          self.otpMailerrormsg = "Please enter valid 6 digit OTP";
          this.isFlag = false;
          this.emailOtp1 = '';
          this.emailOtp2 = '';
          this.emailOtp3 = '';
          this.emailOtp4 = '';
          this.emailOtp5 = '';
          this.emailOtp6 = '';
          this.$sunidhi.isdisableProceedBtn = true;
        }
  
  
  
        if (this.isFlag) {
          var genzdata = await db.TbGenz.where("UserId").anyOf(1).toArray();
          if (genzdata != null && genzdata.length > 0) {
            if (genzdata[0].LoginUserID) {
              self.loginUserIDValue = genzdata[0].LoginUserID;
              // self.loginUserIDValueEncrypt = self.loginUserIDValue;
            }
          }
  
          if (self.isDispForgotPwdOTP) {
            await self.ValidateForgottenPasswordOTP();
          } else if (self.isDispTwoFactorAuthOTP) {
            await self.DSAOtp(self.loginUserIDValue, self.emailOtp);
          }
  
  
  
        }
        if (!this.isFlag) {
          setTimeout(() => {
            self.PreLoader = false;
          }, 500);
          return;
        }
  
      },
  
      async DSAOtp(loginIDEncrypt, otpEntered) {
        var self = this;
        const sunidhi = reactive(sunidhiPlugin);
        var genzdata = await db.TbGenz.where("UserId").anyOf(1).toArray();
  
  
  
        try {
          const response = await axios.post(this.$sunidhi.externalURL + 'DSAOtp/', {}, {
          // const response = await axios.post(this.$sunidhi.externalURL + 'DSAOtp_test/', {}, {
            // type: 'POST',
            headers: {
              "PWAUserLoginId": loginIDEncrypt,
              "TFAOTP": otpEntered,
              "PWAUserType": this.$sunidhi.PwaUserType,
              // "PWAUserSessionId": genzdata[0].PWAUserSessionId,
              "PWAUserSessionId":  getSessionId(),
              "ngrok-skip-browser-warning": '69420',
              'DSAUserId': genzdata[0].DSAUserId
            },
            responseType: "json"
          });
  
          const data = response.data;
          console.log("DSAOtp",response);
          
          var validResponse = false;
          // validResponse = await this.$sunidhi.validateResponseSessionId(data);

          var fetchSessionID = getSessionId();
          console.log("fetchSessionID", fetchSessionID)

          if (
            fetchSessionID === null ||
            fetchSessionID === '' ||
            fetchSessionID === undefined
          ) {
            validResponse = false;
          } else {
            validResponse = true;
          }
          console.log("Valid Response ?", validResponse);

          if (data) {
            if (data.DSAAuthenticationStatus == "01") {
              console.log("data", data.DSAAuthenticationStatus)
              self.dsaLoginErrorMsg = data.message;
              alert(data.message);
              setTimeout(() => {
                self.PreLoader = false;
              }, 500);
              document.getElementById("loginModal").style.display = "";
              self.isModalpopUp = true;
              self.errorPopup = true;
              self.changePasswordPopup = false;
            } else if (data.DSAAuthenticationStatus !== "01") {

            if (data.PWAUserSessionStatus === "expired") {
              setTimeout(() => {
                self.PreLoader = false;
              }, 500);
              self.$sunidhi.logoutBtnDisp = false;
              router.push({ name: 'SessionTimeout' });
            } else if (data.PWAUserSessionStatus === "Active" && validResponse) {
              if (data.OTPVerificationStatus) {
                switch (data.OTPVerificationStatus) {
                  case "70": // Success
                    self.otpSuccessMsg = data.OTPVerificationMessage;
                    setTimeout(() => {
                      self.PreLoader = false;
                    }, 500);
                    sunidhi.logoutBtnDisp = true;
                    router.push({ name: 'menuSelection' });
                    break;
                  case "71": // OTP has been expired. please request for OTP again
                    self.otpMailerrormsg = data.OTPVerificationMessage;
                    self.emailOtp1 = "";
                    self.emailOtp2 = "";
                    self.emailOtp3 = "";
                    self.emailOtp4 = "";
                    self.emailOtp5 = "";
                    self.emailOtp6 = "";
                    this.isFlag = false;
                    this.$sunidhi.isdisableProceedBtn = true;
                    self.otpEmail = true;
                    self.otpTimerMail = "";
                    if (!this.isFlag) {
                      setTimeout(() => {
                        self.PreLoader = false;
                      }, 500);
                      return;
                    }
                    break;
                  case "72": // Incorrect OTP entered for verification. Please try again
                    self.mailOtpCount++;
                    if (self.mailOtpCount < 2) {
                      self.otpMailerrormsg = data.OTPVerificationMessage;
                      self.emailOtp1 = "";
                      self.emailOtp2 = "";
                      self.emailOtp3 = "";
                      self.emailOtp4 = "";
                      self.emailOtp5 = "";
                      self.emailOtp6 = "";
                      this.isFlag = false;
                      this.$sunidhi.isdisableProceedBtn = true;
                      if (!this.isFlag) {
                        setTimeout(() => {
                          self.PreLoader = false;
                        }, 500);
                        return;
                      }
                    } else if (self.mailOtpCount === 2) {
                      self.otpMailerrormsg = "Incorrect OTP entered. Remaining 1 attempt left";
                      self.emailOtp1 = "";
                      self.emailOtp2 = "";
                      self.emailOtp3 = "";
                      self.emailOtp4 = "";
                      self.emailOtp5 = "";
                      self.emailOtp6 = "";
                      self.otpEmail = true;
                      this.$sunidhi.isdisableProceedBtn = true;
                      setTimeout(() => {
                        self.PreLoader = false;
                      }, 500);
                    } else if (self.mailOtpCount > 2) {
                      alert("Maximum Invalid attempts reached. Please login again.");
                      setTimeout(() => {
                        self.PreLoader = false;
                      }, 500);
                      this.$sunidhi.logoutBtnDisp = false;
                      router.push({ name: "LoginPage" });
                      // window.location.reload(true);
                    }
                    break;
                  default:
                    self.otpMailerrormsg = data.OTPVerificationMessage;
                    this.$sunidhi.isdisableProceedBtn = true;
                    this.isFlag = false;
                    if (!this.isFlag) {
                      setTimeout(() => {
                        self.PreLoader = false;
                      }, 500);
                      return;
                    }
                    break;
                }
              }
            }else{
              setTimeout(() => {
              self.PreLoader = false;
            }, 1000);
            alert(this.$sunidhi.sessionIdErrorMsg);
            router.push({ name: 'LoginPage' });

            }
          }
        } else {
           setTimeout(() => {
            self.PreLoader = false;
          }, 500);
          console.error("DSAOtp Error:", error);
          alert("No response available from backend");
        }
        } catch (error) {
          debugger
          if(error.message === 'Duplicate session'){
            console.log("error otp page :", error.message)
             setTimeout(() => {
            self.PreLoader = false;
          }, 1000);
            return;
          }
          setTimeout(() => {
            self.PreLoader = false;
          }, 500);
          console.error("DSAOtp Error:", error);
          alert(this.$sunidhi.exceptionalNetworkError);
          // if (error.code === "ERR_NETWORK") {
          //   alert(this.$sunidhi.exceptionalNetworkError);
          // } else {
          //   alert(this.$sunidhi.exceptionalGeneralError);
          // }
        }
      },
  
        async ValidateForgottenPasswordOTP (){
          var self = this;
          // eslint-disable-next-line no-unused-vars
          var genzdata = await db.TbGenz.where("UserId").anyOf(1).toArray();
          var copySunidhi = this.$sunidhi;
             try{
            
              $.ajax({
                      url: externalURL+"ValidateForgottenPasswordOTP/",
                      type: 'POST',
                      headers: {
                          "PWADSALoginId": self.loginUserIDValue,
                          "PWAUserType": this.$sunidhi.PwaUserType,
                          "FPOTP": self.emailOtp,
                          // "PWAUserSessionId" : genzdata[0].PWAUserSessionId
                      },
                      responseType: "application/text",
                      success: async function (data) {
                        console.log("ValidateForgottenPasswordOTP", data)
                          if(data){
                            if(data.DSAAuthenticationStatus !=="01"){
                              if(data.OTPVerificationStatus){
                                  switch(data.OTPVerificationStatus){
                                    case "70": // Success
                                      self.otpSuccessMsg = data.OTPVerificationMessage;
                                      // self.emailSuccess = true;
                                      setTimeout(() => {
                                        self.PreLoader = false;
                                      }, 500);
                                      copySunidhi.logoutBtnDisp = false;
                                      router.push({ name: 'setNewPassword' });
  
                                      break;
  
                                    case "71": // OTP has been expired. please request for OTP again
                                      self.otpMailerrormsg = data.OTPVerificationMessage;
                                      self.emailOtp1 ="";
                                      self.emailOtp2="";
                                      self.emailOtp3 = ""; 
                                      self.emailOtp4 = "";
                                      self.emailOtp5 = ""; 
                                      self.emailOtp6 = "";
                                      this.isFlag = false;
                                      // self.emailSuccess = false;
                                      self.otpEmail=true;
                                      // $("#emailResendBtn").removeClass("activeLink");
                                      // $("#emailResendBtn").addClass("activeLink");
                                        self.otpTimerMail = "";
                                        copySunidhi.isdisableProceedBtn = true;
                                        if(!this.isFlag){
                                          setTimeout(() => {
                                            self.PreLoader = false;
                                          },500);
                                          return;
                                        }
                                        break;
  
                                    case "72"://Incorrect OTP entered for verification. Please try again
                                    self.mailOtpCount++;
                                    if(self.mailOtpCount < 2){
                                      self.otpMailerrormsg = data.OTPVerificationMessage;
                                      self.emailOtp1 ="";
                                      self.emailOtp2="";
                                      self.emailOtp3 = ""; 
                                      self.emailOtp4 = "";
                                      self.emailOtp5 = ""; 
                                      self.emailOtp6 = "";
                                      this.isFlag = false;
                                      copySunidhi.isdisableProceedBtn = true;
                                      // self.emailSuccess = false;
                                      if(!this.isFlag){
                                        setTimeout(() => {
                                          self.PreLoader = false;
                                        },500);
                                        return;
                                      }
                                    }
                                    else if(self.mailOtpCount == 2) {
                                  self.otpMailerrormsg = "Incorrect OTP entered. Remaining 1 attempt left"
                                      self.emailOtp1 ="";
                                      self.emailOtp2="";
                                      self.emailOtp3 = ""; 
                                      self.emailOtp4 = "";
                                      self.emailOtp5 = ""; 
                                      self.emailOtp6 = "";
                                  self.otpEmail=true;
                                  copySunidhi.isdisableProceedBtn = true;
                                  setTimeout(() => {
                                          self.PreLoader = false;
                                        },500);
                                  // $("#emailResendBtn").removeClass("activeLink");
                                  // $("#emailResendBtn").addClass("activeLink");
                                  // self.otpTimerMail = "";
                              }
                              else if( self.mailOtpCount >2){
                              //    self.PreLoader = true;
                              alert("Maximum Invalid attempts reached.Please enter the username again.");
                              setTimeout(() => {
                                          self.PreLoader = false;
                                        },500);
                                 this.$sunidhi.logoutBtnDisp = false;
                                  router.push({ name: "ForgotPassword" });
                                  window.location.reload(true);
                              }
  
                                      break;
  
                                    default:
                                    self.otpMailerrormsg = data.OTPVerificationMessage;
                                    this.isFlag = false;
                                      // self.emailSuccess = false;
                                      if(!this.isFlag){
                                        setTimeout(() => {
                                          self.PreLoader = false;
                                        },500);
                                        return;
                                      }
  
                                      break;
  
  
                                  }
                              }
                            }else{
                              alert(data.message);
                              setTimeout(() => {
                                          self.PreLoader = false;
                                        },500);
                              
                            }
                             
                            // }
                          }
                      } ,error: function (ex) {
                    setTimeout(() =>{
                        self.PreLoader = false;
                      },500);
                              console.log(ex);
                              // alert("Network error: Something is wrong with your internet connection. Please try again after restoring the connection.");
                          }
  
            });
          }catch (error) {
            if(error === 'Duplicate session'){
             setTimeout(() => {
            self.PreLoader = false;
          }, 1000);
            return;
          }
            // console.log(error)
          }
      // }
            },
  
  
      async otpResendMail() {
        var self = this;
        self.otpMailerrormsg = ""
        self.emailOtp1 = "";
        self.emailOtp2 = "";
        self.emailOtp3 = "";
        self.emailOtp4 = "";
        self.emailOtp5 = "";
        self.emailOtp6 = "";
        var genzdata = await db.TbGenz.where("UserId").anyOf(1).toArray();
        if (genzdata != null && genzdata.length > 0) {
          if (genzdata[0].LoginUserID) {
            self.loginUserIDValue = genzdata[0].LoginUserID;
            self.loginPwd = genzdata[0].DSALoginPwd;
  
          }
        }
        if (self.isDispForgotPwdOTP) {
          await this.$sunidhi.ValidatePWADSALoginId(self.loginUserIDValue);
  
        }
        if (self.isDispTwoFactorAuthOTP) {
          await self.resendDSALoginAuthentication(self.loginUserIDValue, self.loginPwd)
        }
        self.otpTimerMail = 180;
        self.isOtpMail = true;
  
      },
  
      async resendDSALoginAuthentication(loginID, loginPwd) {
      var self = this;
      var genzdata = await db.TbGenz.where("UserId").anyOf(1).toArray();
      
      try {
          const response = await axios.post(this.$sunidhi.externalURL + "DSALoginAuthentication_check/", null, {
              headers: {
                  'UserName': loginID,
                  'Password': loginPwd,
                  "PwaUserType": "DSA",
                  // "PWAUserSessionId": genzdata[0].PWAUserSessionId,
                  "PWAUserSessionId": getSessionId(),
                  "ngrok-skip-browser-warning": '69420'
              },
              responseType: "text"
          });
  
          if (response.data) {
              const data = response.data;
              if (data.DSAAuthenticationStatus) {
                  if (data.DSAAuthenticationStatus == "00" || data.DSAAuthenticationStatus == "76") {
                      setTimeout(() => {
                          self.PreLoader = false;
                      }, 500);
                  }
              }
          }
  
      } catch (error) {
        if(error === 'Duplicate session'){
             setTimeout(() => {
            self.PreLoader = false;
          }, 1000);
            return;
          }
          setTimeout(() => {
              self.PreLoader = false;
          }, 500);
          console.error(error);
          // alert("Network error: Something is wrong with your internet connection. Please try again after restoring the connection.");
      }
  },
  
  
      OTPSuccess() {
        // var self = this;
        router.push({ name: 'menuSelection' });
        // router.push({ name: 'initial_info' });
      }
    }
  };
  </script>

<style lang="css" scoped>

.LogoutStyle{
  float: right;
  display: block !important;
}
.resendOtp{
	border: none;
    box-shadow: none!important;
    margin-top: -10px!important;
    /* float: right; */
	color: #938e8e!important;
	background-color: transparent!important;

}
.activeLink{
color: #e3352a!important;

}
.activeLink:hover{
 text-decoration-line: underline;
 }
  .modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .modal {
    background: #FFFFFF;
    box-shadow: 2px 2px -1px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
	width:50%;
  }

  .modal-header,
  .modal-footer {
    padding: 15px;
    display: flex;
  }

  .modal-header {
    position: relative;
    border-bottom: 1px solid #eeeeee;
    color: #4AAE9B;
    justify-content: space-between;
  }

  .modal-footer {
    border-top: 1px solid #eeeeee;
    flex-direction: column;
    justify-content: flex-end;
  }

  .modal-body {
    position: relative;
    padding: 20px 10px;
  }

  .btn-close {
    position: absolute;
    top: 0;
    right: 0;
    border: none;
    font-size: 20px;
    padding: 10px;
    cursor: pointer;
    font-weight: bold;
    color: #4AAE9B;
    background: transparent;
  }

  .btn-green {
    color: white;
    background: #4AAE9B;
    border: 1px solid #4AAE9B;
    border-radius: 2px;
  }

  .float-child {
    width: 13%;
    float: left;
    padding: 0px;
    margin-right: 8px;
  }

  .preLoginHeaderstyle {
    text-align: center !important;
    font-size: 20px !important; 
    padding-top: 70px !important;
  }

  
  @media only screen and (max-width: 959px) {
            #createAccount{
                padding-top: 0px !important;
                text-align: center !important;

            }}

 .col1 {
    float: left;
    width: 90%;
}

 .col2 {
    float: right; 
    width: 10%;
}

.cardStyle {
    width: 50%;
    border-color: white;
    background: transparent !important;
    /* padding: 36px 0px; */
    border-radius: 62px;
    box-shadow: rgba(0, 0, 0, 0.25) 0px 0px 2px 0px;
    box-shadow: none;
    transform: translate(70%, 4%);
  }

  .otpPopUp{
  padding-bottom: 8px !important;
  /* transform: translate(29%, 9%) !important; */
  /* width: 26rem; */
  width: 100%;
  position: absolute;
  transform: translate(35%, 30px);
}

.otpModal {
width: 26rem;
border-radius: 15px;
}

.otpCardStyle {
    width: 50%;
    border-color: white;
    background: #fff;
    padding: 36px 0;
    border-radius: 15px;
    /* margin: 30px 0; */
    box-shadow: 0px 0 2px 0 rgba(0,0,0,0.25);
    transform: translate(50%,8%);
  }

  .otpSuccessPopUp{
    padding-bottom: 8px !important;
    /* width: 50% !important;
    position: absolute;
    transform: translate(47.8%, -41%) !important; */
}

.pwdUpdatedStyle {
  color: red;
  font-size: 20px; 
}
.submitButton {
  width: 70%;
  height: 40px;
  margin: auto;
  margin-bottom: 5%;
  display: block;
  color: #fff;
  background-color: #003883;
  border-color: #003883;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.035);
  border-radius: 4px;
  font-size: 20px;
  cursor: pointer;
}

/* .container{
  padding: 0 !important;
} */
@media only screen and (max-width: 959px) {
            #mobNumStyle{
                width: 60%;

            }}
@media only screen and (max-width: 959px) {
          #isdCodeStyle{
                width: 40%;

            }}

/* @media screen and (max-width: 959px) {
  .otpPopUp{
    padding-bottom: 8px !important; 
    width: 98% !important;
    position: absolute !important;
    transform: translate(25.8%, 5%) !important;
}} */


/* @media screen and (max-width: 320px) {

  .otpPopUp{
    padding-bottom: 8px !important;
    width: 90% !important;
    position: absolute !important;
    transform: translate(-7%, 4%) !important;
 }} */
@media (min-width: 312px) and (max-width: 399px) {

  .otpPopUp{
    padding-bottom: 8px !important;
    width: 90% !important;
    position: absolute !important;
    transform: translate(4%, 4%) !important;
 }}
@media (min-width: 400px) and (max-width: 410px) {

  .otpPopUp{
    padding-bottom: 8px !important;
    width: 90% !important;
    position: absolute !important;
    transform: translate(6.5%, 5%) !important;
 }}
@media (min-width: 412px) and (max-width: 414px) {

  .otpPopUp{
    padding-bottom: 8px !important;
    width: 90% !important;
    position: absolute !important;
    transform: translate(7%, 5%) !important;
 }
 .otpSuccessPopUp{
    position: absolute;
    transform: translate(-4.2%, -41%) !important;
    padding: 2%;
    width: 100% !important;
 }
}
@media screen and (max-width: 540px) {

  .otpPopUp{
    padding-bottom: 8px !important;
    width: 90% !important;
    position: absolute !important;
    transform: translate(7%, 8%) !important;
 }}

@media screen and (max-width: 280px) {

  .otpPopUp{
    padding-bottom: 8px !important;
    width: 90% !important;
    position: absolute !important;
    transform: translate(-15%, 6%) !important;
 }}

 /* @media screen and (max-width: 375px) {
.otpPopUp{
  padding-bottom: 8px !important;
  width: 90% !important;
  position: absolute !important;
  transform: translate(0%, 4%) !important;
}} */

@media (min-width: 700px) and (max-width: 1024px){
    .otpPopUp{
  padding-bottom: 8px !important;
  width: 90% !important;
  position: absolute !important;
  transform: translate(28%, 10%) !important;
}
}

@media screen and (max-width: 959px) {

  .otpSuccessPopUp{
    padding-bottom: 8px !important;
    width: 50% !important;
    position: absolute;
    transform: translate(47.8%, -41%) !important;
}
}
/* @media screen and (max-width: 712px) {

.otpPopUp{
  padding-bottom: 8px !important;
  width: 90% !important;
  position: absolute !important;
  transform: translate(27%, 10%) !important;
}}
@media screen and (max-width: 1024px) {

  .otpPopUp{
    padding-bottom: 8px !important;
    width: 100% !important;
    position: absolute !important;
    transform: translate(32%, 10%);
 }} */
 
</style>
